'use client';

export default function CookiesPage() {
  const openCookieSettings = () => {
    if (typeof window !== 'undefined') {
      const win = window as unknown as { cookiehub?: { openSettings: () => void } };
      if (win.cookiehub) {
        win.cookiehub.openSettings();
      }
    }
  };

  return (
    <section className="legal-page">
      <div className="legal-content">
        <h1>Zásady cookies</h1>
        <p className="legal-updated">Poslední aktualizace: 20. 2. 2026</p>

        <h2>Co jsou cookies?</h2>
        <p>
          Cookies jsou malé textové soubory, které se ukládají do vašeho prohlížeče při návštěvě webových stránek.
          Slouží k zajištění fungování webu, analýze návštěvnosti a zobrazování relevantních reklam.
        </p>

        <h2>Jaké cookies používáme</h2>

        <h3>Nezbytné cookies</h3>
        <p>Tyto cookies jsou nutné pro správné fungování webu. Nelze je vypnout.</p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Poskytovatel</th>
              <th>Účel</th>
              <th>Expirace</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>cookiehub</td>
              <td>CookieHub</td>
              <td>Uložení vašeho nastavení souhlasu s cookies</td>
              <td>365 dní</td>
            </tr>
          </tbody>
        </table>

        <h3>Analytické cookies</h3>
        <p>Pomáhají nám porozumět, jak návštěvníci používají web. Data jsou anonymizována.</p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Poskytovatel</th>
              <th>Účel</th>
              <th>Expirace</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga, _ga_*</td>
              <td>Google Analytics</td>
              <td>Rozlišení unikátních uživatelů a sledování návštěvnosti</td>
              <td>2 roky</td>
            </tr>
          </tbody>
        </table>

        <h3>Marketingové cookies</h3>
        <p>Slouží k zobrazování relevantních reklam a měření efektivity kampaní.</p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Poskytovatel</th>
              <th>Účel</th>
              <th>Expirace</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_fbp, fr</td>
              <td>Meta (Facebook)</td>
              <td>Sledování konverzí a cílení reklam na Facebooku</td>
              <td>90 dní</td>
            </tr>
            <tr>
              <td>_ttp, tt_*</td>
              <td>TikTok</td>
              <td>Sledování konverzí a cílení reklam na TikToku</td>
              <td>13 měsíců</td>
            </tr>
            <tr>
              <td>_gcl_au</td>
              <td>Google Ads</td>
              <td>Sledování konverzí z Google Ads kampaní</td>
              <td>90 dní</td>
            </tr>
          </tbody>
        </table>

        <h2>Jak spravovat cookies</h2>
        <p>
          Své preference ohledně cookies můžete kdykoli změnit kliknutím na tlačítko níže
          nebo v nastavení vašeho prohlížeče.
        </p>
        <button onClick={openCookieSettings} className="cookie-settings-btn" type="button">
          Upravit nastavení cookies
        </button>

        <h2>Více informací</h2>
        <p>
          Podrobné informace o zpracování osobních údajů najdete na stránce{' '}
          <a href="/ochrana-osobnich-udaju">Ochrana osobních údajů</a>.
        </p>
      </div>
    </section>
  );
}
